import styled from 'styled-components';
import ClickOutside from 'library/components/click-outside';
import Masony from 'react-masonry-component';

const Container = styled(Masony)`
  ${({ resized }) => `
    width: ${resized ? 'calc(100% - 630px)' : 'calc(100% - 120px)'};
  `}   
  margin: 20px 60px;
  display: flex;
  justify-content: center;
`;

const Row = styled.div``;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 540px;
  z-index: 20;
`;

export const StyledClickOutside = styled(ClickOutside)`
  display: inline-block;
`;

export {
  Container, Row, Overlay,
};
